export default __webpack_public_path__ + "static/media/D2006_10_21_Tixtla.efa9c2b0.jpg";